import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    uniqueHash: String
  }

  connect() {
    if(this.hasUniqueHashValue) {
      this.pushDataLayer('view_advert_page')
    }
  }

  viewLocation() {
    this.pushDataLayer('view_location')
    
    const localisationElement = document.getElementById('localisation')
    if (localisationElement) {
      const offset = 100 // Offset en pixels pour ne pas cacher le titre
      const elementPosition = localisationElement.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }

  viewVirtualVisit() {
    this.pushDataLayer('view_virtual_visit')
  }

  viewPlan() {
    this.pushDataLayer('view_plan')
  }

  viewStreetView() {
    this.pushDataLayer('view_street_view')
  }

  pushDataLayer(event) {
    // new GA4 tracking plan
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': event,
      'unique_hash': this.uniqueHashValue
    })
  }
}
